import { Injectable } from '@angular/core';
import { Division } from './division.dto';
import { DIVISIONS_COLLECTION, ID_FIELD_OPTIONS, Query, SearchResult } from '@damofire/data-commons';
import { firstValueFrom, Observable } from 'rxjs';
import { collection, collectionData, doc, docData, getFirestore, query, where } from '@angular/fire/firestore';
import { map } from 'rxjs/operators';
import { FirebaseObservableService, FirebaseObservableServiceFactory } from '@damofire/data-angular-commons';

export function getDivisionById(id: string): Observable<Division> {
  return docData<Division>(doc(getFirestore(), `${DIVISIONS_COLLECTION}/${id}`), ID_FIELD_OPTIONS);
}

@Injectable()
export abstract class DivisionService {
  abstract search(q: Query): Promise<SearchResult<Division>>;
  abstract observeSearch(q: Query): Observable<SearchResult<Division>>;
  abstract getById(id: string): Promise<Division>;
  abstract getOrganizationDivisionCount(orgId: string): Observable<number>;
}

@Injectable()
export class FirebaseDivisionService implements DivisionService {
  private readonly service: FirebaseObservableService<Division>;

  constructor(private readonly firebaseObservableServiceFactory: FirebaseObservableServiceFactory) {
    this.service = firebaseObservableServiceFactory.createService(DIVISIONS_COLLECTION);
  }

  async getById(id: string): Promise<Division> {
    return firstValueFrom(docData<Division>(doc(getFirestore(), `${DIVISIONS_COLLECTION}/${id}`), ID_FIELD_OPTIONS));
  }

  getOrganizationDivisionCount(orgId: string): Observable<number> {
    return collectionData<Division>(query(collection(getFirestore(), DIVISIONS_COLLECTION), where(`organization._id`, '==', orgId)), ID_FIELD_OPTIONS).pipe(
      map((divisions) => {
        return divisions.length;
      }),
    );
  }

  search(q: Query): Promise<SearchResult<Division>> {
    return firstValueFrom(this.observeSearch(q));
  }

  observeSearch(q: Query): Observable<SearchResult<Division>> {
    return this.service.observeCollectionSearch(q, ['name', 'organization.name', 'contactInfo.addresses', 'contactInfo.postalCode', 'contactInfo.city']);
  }
}
